"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/web.dom.iterable");
function capitalizeFirstLetter(string) {
  return string.charAt(0) + string.slice(1);
}

// 找到interface文件夹下以.js命名的文件
var requireComponent = require.context('./interface', true, /\.js$/);
var interfaceList = {};
requireComponent.keys().forEach(function (fileName) {
  var a = fileName.lastIndexOf('/');
  var name = '.' + fileName.slice(a);
  var componetName = capitalizeFirstLetter(name.replace(/^\.\//, '').replace(/\.\w+$/, ''));
  var componetConfig = requireComponent(fileName).default;
  interfaceList[componetName] = componetConfig;
});
var _default = exports.default = interfaceList;